import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const LocalFonts = () => (
    <Global
        styles={`
            /* Helvetica Neue LT Std */
            @font-face {
                font-family: 'HelveticaNeueLTStd';
                font-style: normal;
                font-weight: 700;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Bd.woff2'
                )}) format('woff2');
                descent-override: 0%;
            }
            @font-face {
                font-family: 'HelveticaNeueLTStd';
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Md.woff2'
                )}) format('woff2');
                descent-override: 0%;
            }
            @font-face {
                font-family: 'HelveticaNeueLTStd';
                font-style: normal;
                font-weight: normal;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Roman.woff2'
                )}) format('woff2');
                descent-override: 0%;
            }

            /* Helvetica Neue LT Std - Form Elements */
            @font-face {
                font-family: 'HelveticaNeueLTStd-Form';
                font-style: normal;
                font-weight: normal;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/HelveticaNeueLTStd-Roman.woff2'
                )}) format('woff2');
            }

            input, textarea, select {
                font-family: 'HelveticaNeueLTStd-Form', sans-serif;
            }

            /* Azo Sans */
            @font-face {
                font-family: 'AzoSans';
                font-style: normal;
                font-weight: normal;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/AzoSansRegular.woff2')}) format('woff2');
            }
            @font-face {
                font-family: 'AzoSans';
                font-style: normal;
                font-weight: medium;
                font-display: swap;
                src: url(${getAssetUrl('static/fonts/AzoSansMedium.woff2')}) format('woff2');
            }
        `}
    />
)

export {LocalFonts}
